module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.5242/images/default-avatar.png"